import i18n from '@/i18n'
// OrderBill.OrderBill15
export const columns = [
  {
    columnId: 6,
    name: i18n.t('wzbg.wz6'), // 订单状态
    key: 'orderStatus',
    minWidth: 75,
    align: 'center',
  },
  {
    columnId: 1,
    name: i18n.t('OrderDetail.OrderDetail1' || '订单信息'),
    key: 'handle',
    align: 'left',
    minWidth: '180',
  },
  //   {
  //     columnId: 2,
  //     name: i18n.t('orderList.orderList2'),
  //     key: 'splitOrderId',
  //     width: 70,
  //   },
  // {
  //     columnId: 3,
  //     name: i18n.t('OrderDetail.OrderDetail3'),
  //     key: "tongkunNo",
  //     width: 90,
  // },
  //   {
  //     columnId: 3,
  //     name: i18n.t('defe.defe3'),
  //     key: 'createTime',
  //     minWidth: 120,
  //   },
  {
    columnId: 4,
    name: i18n.t('saas.saas01' || '国内信息'),
    key: 'trackingNumberCn',
    minWidth: 80,
    align: 'left',
  },
  // {
  //     columnId: 5,
  //     name: i18n.t('OrderBill.OrderBill17'),
  //     key: "trackingNumberJpn",
  //     minWidth: 120,
  // },
  // {
  //     columnId: 7,
  //     name: "颜色",
  //     key: "colour",
  // },
  // {
  //     columnId: 8,
  //     name: "尺寸",
  //     key: "goodsSize",
  // },
  // {
  //     columnId: 9,
  //     name: "品番",
  //     key: "goodsNumber",
  // },
  {
    columnId: 7,
    name: i18n.t('createOrder.createOrder13'),
    key: 'shopInfo',
    minWidth: 140,
    align: 'center',
  },
  {
    columnId: 66,
    name: i18n.t('createOrder.createOrder127'),
    key: 'merchantRemark',
    minWidth: 160,
    align: 'center',
  },
  {
    columnId: 8,
    name: `${i18n.t('orderList.orderList118')}(元)`,
    key: 'price',
    width: 80,
  },
  // {
  //   columnId: 9,
  //   name: i18n.t('orderList.orderList119'),
  //   key: 'chineseFreightFee',
  //   minWidth: 80,
  // },
  // {
  //     columnId: 10,
  //     name: "商品数量",
  //     key: "goodsCount",
  // },
  // {
  //     columnId: 11,
  //     name: "待装箱数",
  //     key: "waitBoxCount",
  // },
  // {
  //     columnId: 12,
  //     name: "退货数量",
  //     key: "refundCount",
  // },
  // {
  //     columnId: 13,
  //     name: "销毁数量",
  //     key: "destroyCount",
  // },
  {
    columnId: 10,
    name: i18n.t('orderList.orderList29'),
    key: 'shopNum',
    width: 230,
  },
  {
    columnId: 14,
    name: i18n.t('OrderBill.OrderBill18'),
    key: 'inspection',
    minWidth: 100,
  },
  {
    columnId: 15,
    name: i18n.t('orderList.orderList175'),
    key: 'categoryFlag',
    minWidth: 90,
  },
  /*{
    columnId: 16,
    name: i18n.t('createOrder.createOrder27'),
    key: 'putIntent',
    width: '70',
  },*/
  //   {
  //     columnId: 17,
  //     name: i18n.t('feedback.feedback9'),
  //     key: 'pictureUrl',
  //     minWidth: '85',
  //   },
  {
    columnId: 18,
    name: i18n.t('createOrder.createOrder100'),
    key: 'orderType',
    width: '160',
  },
  {
    columnId: 19,
    name: i18n.t('OrderBill.OrderBill19'),
    key: 'badInfo',
    minWidth: '120',
    align: 'center',
  },
  // {
  //     columnId: 19,
  //     name: "不良待处理",
  //     key: "badCount",
  // },
  // {
  //     columnId: 20,
  //     name: "补发中",
  //     key: "reissueCount",
  // },
  // {
  //     columnId: 21,
  //     name: "换货中",
  //     key: "exchangCount",
  // },

  // {
  //   columnId: 22,
  //   name: i18n.t('OrderBill.OrderBill21'),
  //   key: 'playVideo',
  //   minWidth: 120,
  //   align: 'center',
  // },
  {
    columnId: 23,
    name: i18n.t('OrderBill.OrderBill23'),
    key: 'checkReport',
    minWidth: 120,
    align: 'center',
  },
]
